import axiosInstance from './axiosInstance';

const fetcher = (url) => axiosInstance.get(url).then((response) => response);

export default fetcher;
